export const palette = [
  "#027360", "#1c4e80", "#ff9f1c", "#9b2226", "#6c757d",
  "#17a2b8", "#f77f00", "#4361ee", "#2a9d8f", "#c1121f",
];

export const CAGR_ORDER = ["aktiva", "trzby", "ebitda", "zasoby", "zadluzenost"];
export const METRIC_LABELS_CZ = {
  "aktiva": "Aktiva (Assets)",
  "trzby": "Tržby (Revenue)",
  "ebitda": "EBITDA",
  "zasoby": "Zásoby (Inventory)",
  "zadluzenost": "Zadluženost (Debt)",
};

export const RATIO_GROUPS = {
  rentabilita: [
    { key: "Provozní marže__median", name: "Provozní Marže" },
    { key: "EBITDA marže__median", name: "EBITDA Marže" },
    { key: "ROS__median", name: "ROS" },
    { key: "ROA__median", name: "ROA" },
    { key: "ROE__median", name: "ROE" },
  ],
  likvidita: [
    { key: "Likvidita běžná__median", name: "Běžná (Current)" },
    { key: "Likvidita pohotová__median", name: "Pohotová (Quick)" },
    { key: "Likvidita okamžitá__median", name: "Okamžitá (Cash)" },
  ],
  zadluzenost: [
    { key: "Zadluženost celková__median", name: "Celková" },
    { key: "Zadluženost dlouhodobá__median", name: "Dlouhodobá" },
  ],
  obratkovost: [
    { key: "Obrat aktiv__median", name: "Obrat Aktiv" },
    { key: "Obrat zásob__median", name: "Obrat Zásob" },
  ],
};

export const styles = {
  description: {
      fontSize: "0.9rem", color: "#6c757d", marginTop: "-0.5rem",
      marginBottom: "1rem", lineHeight: "1.4", maxWidth: "90%"
  },
  sectionDescription: {
      fontSize: "1rem", color: "#555", marginTop: "-0.5rem", marginBottom: "1.5rem"
  }
};

export const safeNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};
export const fmt = (v) => (Number.isFinite(v) ? v.toFixed(2) : "—");
export const fmtPercent = (v) => (Number.isFinite(v) ? (v * 100).toFixed(1) + "%" : "—");
export const fmtInt = (v) => (Number.isFinite(v) ? v.toFixed(0) : "—");

export const buildBarOption = (data) => ({
  title: { show: false },
  tooltip: { trigger: "axis", formatter: (p) => `${p[0].name}: <b>${(p[0].value * 100).toFixed(1)}%</b>` },
  grid: { left: 10, right: 10, top: 30, bottom: 20, containLabel: true },
  xAxis: { type: "category", data: data.map(d => d.label), axisLabel: { interval: 0, rotate: 15, fontSize: 11 } },
  yAxis: { type: "value", axisLabel: { formatter: (v) => (v * 100).toFixed(0) + "%" } },
  series: [{
    type: "bar",
    data: data.map(d => safeNum(d.value)),
    itemStyle: { color: (p) => (p.value >= 0 ? palette[0] : "#c1121f"), borderRadius: [4, 4, 0, 0] },
    label: { show: true, position: "top", formatter: (p) => (p.value * 100).toFixed(1) + "%" }
  }]
});

export const buildLineOption = (categories, seriesData, valueFormatter = null) => ({
  title: { show: false },
  tooltip: { trigger: "axis", confine: true, valueFormatter },
  legend: { bottom: 0, type: "scroll", padding: [10, 5, 0, 5] },
  grid: { left: 10, right: 10, top: 20, bottom: 35, containLabel: true },
  xAxis: { type: "category", data: categories, boundaryGap: false },
  yAxis: { type: "value", splitLine: { lineStyle: { color: "#e1e7ee" } } },
  series: seriesData.map((s, idx) => ({
    name: s.name,
    type: "line",
    smooth: true,
    symbol: "circle",
    symbolSize: 6,
    data: s.data,
    lineStyle: { width: 3 },
    itemStyle: { color: palette[idx % palette.length] },
  })),
});
